var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { State, Action, Selector } from '@ngxs/store';
import { EditPaintStateModel } from './edit.paint.state.model';
import { SetColorRecipe, ClearColorRecipe, ResetPaint } from './edit.paint.actions';
import { PaintPresetRed } from 'src/app/engine/models/paint-presets.const';
import { PaintDefaults } from '../../models/paint-defaults.model';
import { ScalarFresnelModel } from '../../models/scalar-fresnel.model';
import { ColorFresnelModel } from '../../models/color-fresnel.model';
import { ColorService } from 'src/app/shared/color.service';
var initialState = {
    colorRecipe: PaintPresetRed.recipe
};
var EditPaintState = /** @class */ (function () {
    function EditPaintState(colorService) {
        this.colorService = colorService;
    }
    /**
     * Selectors
     */
    EditPaintState.getColorRecipe = function (state) {
        return state.colorRecipe;
    };
    /**
     * Actions
     */
    EditPaintState.prototype.setColorRecipe = function (context, action) {
        var recipe = __assign({}, action.colorRecipe);
        // When recipe matches defaults, don't include the actual value and just set it to false.
        // This indicates to the serializer that the value doesn't need to be included on an object,
        // resulting in a smaller package size.
        recipe.brightness = (recipe.brightness !== PaintDefaults.brightness) ? recipe.brightness : false;
        recipe.opacity = (recipe.opacity !== PaintDefaults.opacity) ? recipe.opacity : false;
        recipe.contrast = (recipe.contrast !== PaintDefaults.contrast) ? recipe.contrast : false;
        recipe.saturation = (recipe.saturation !== PaintDefaults.saturation) ? recipe.saturation : false;
        if (!(recipe.opacity instanceof ScalarFresnelModel)) {
            recipe.opacity = (recipe.opacity !== PaintDefaults.opacity) ? recipe.opacity : false;
        }
        if (!(recipe.tintColor instanceof ColorFresnelModel)) {
            var tintColor = (typeof recipe.tintColor === 'string') ? this.colorService.hexToRgb(recipe.tintColor, true) : recipe.tintColor;
            recipe.tintColor = (tintColor.toString() !== PaintDefaults.tintColor.toString()) ? tintColor : false;
        }
        context.patchState({
            colorRecipe: __assign({}, recipe)
        });
    };
    EditPaintState.prototype.clearColorRecipe = function (context, action) {
        context.patchState({
            colorRecipe: null
        });
    };
    EditPaintState.prototype.resetPaint = function (context, action) {
        context.setState(initialState);
    };
    __decorate([
        Action(SetColorRecipe),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, SetColorRecipe]),
        __metadata("design:returntype", void 0)
    ], EditPaintState.prototype, "setColorRecipe", null);
    __decorate([
        Action(ClearColorRecipe),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, ClearColorRecipe]),
        __metadata("design:returntype", void 0)
    ], EditPaintState.prototype, "clearColorRecipe", null);
    __decorate([
        Action(ResetPaint),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, ResetPaint]),
        __metadata("design:returntype", void 0)
    ], EditPaintState.prototype, "resetPaint", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [EditPaintStateModel]),
        __metadata("design:returntype", void 0)
    ], EditPaintState, "getColorRecipe", null);
    EditPaintState = __decorate([
        State({
            name: 'editPaint',
            defaults: initialState
        }),
        __metadata("design:paramtypes", [ColorService])
    ], EditPaintState);
    return EditPaintState;
}());
export { EditPaintState };
